import { Msg, MsgService } from "../../msg";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {AlertService, ConstantService} from '@app/_services';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { MsgRecipient } from "@app/_components/msg-recipient/msg-recipient";

@Component({
    selector: "app-msg",
    templateUrl: "./msg.component.html",
    styleUrls: ["./msg.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MsgComponent implements OnInit {

  countries: any;
  constructor(
    private primengConfig: PrimeNGConfig,
    private msgService: MsgService,
    private alertService: AlertService,
    private messageService: MessageService,
    private constantService: ConstantService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    (this.formTitle = data.title),
      (this.msg = data.msg),
      (this.statuses = msgService.statuses);
    this.countries = this.constantService.countries;
  }

  @Input() msg: Msg;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();


  // data
  msgId: number;
  selectedMsgRecipients: any[] = [];

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  statuses: any;

  validationMessages = {
    msgId: [],
    sentDate: [],
    receivedDate: [],
    senderName: [{ type: 'required', message: 'Required' }],
    senderEmail: [{ type: 'required', message: 'Required' }],
    senderMobileNum: [{ type: 'required', message: 'Required' }],
    senderCountryCode: [{ type: 'required', message: 'Required' }],
    subject: [],
    preHeader: [],
    emailHtml: [],
    emailText: [],
    mobileText: [],
    headers: [],
    status: [],
    statusMsg: [],
    confId: [],
    trackingId: [],
    opsNotes: [],
    campaignVars: [],
    msgRecipientAPIList: [],
    topic: [],
    topicId: []
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();

    // if we were passed the whole msg object
    if (this.msg) {
      this.msgService.findById(this.msg?.msgId).subscribe(
        (res: any) => {
          console.log("send message, SUCCESS: " + JSON.stringify(res));
          this.msg = res.data.msg;
          this.msgId = this.msg.msgId;
          this.fixDates();
          this.form1.patchValue(this.msg);
        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
      );
    }
  }

  updateEmailRecipients(selectedRecipients) {
    this.selectedMsgRecipients = selectedRecipients;
    console.log("Selected recipients in msg component:");
    console.log(this.selectedMsgRecipients);
  }

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message: "Are you sure you want to delete Id# " + this.msgId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      // const emailRecipients: MsgRecipient[] = [];
      // this.selectedMsgRecipients.forEach(msgRecipientId => {
      //   const msgRecipient = new MsgRecipient();
      //   msgRecipient.msgRecipientId = msgRecipientId;
      //   emailRecipients.push(msgRecipient);
      // });
      // this.form1.value.msgRecipientAPIList = emailRecipients;
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.msgService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msg = res.data.msg;
          this.doAdd.emit(this.msg);
        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("msg: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.msgService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msg = res.data.msg;
          this.doUpdate.emit(this.msg);
        },
        (err: any) => {
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.msgService.delete(this.msg.msgId).subscribe(
        (res: any) => {
          console.log("msg-delete SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.doDelete.emit(this.msg);
        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  sendMail() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      const emailRecipients: MsgRecipient[] = [];
      this.selectedMsgRecipients.forEach(msgRecipientId => {
        const msgRecipient = new MsgRecipient();
        msgRecipient.msgRecipientId = msgRecipientId;
        emailRecipients.push(msgRecipient);
      });
      this.form1.value.msgRecipientAPIList = emailRecipients;
      console.log("send message, post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.msgService.send(this.form1.value).subscribe(
        (res: any) => {
          console.log("send message, SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msg = res.data.msg;
          this.doAdd.emit(this.msg);
        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      msgId: [this.msgId],
      sentDate: [],
      receivedDate: [],
      senderName: ['', Validators.required],
      senderEmail: [],
      senderMobileNum: [],
      senderCountryCode: [],
      subject: ['', Validators.required],
      preHeader: [],
      emailHtml: [],
      emailText: [],
      mobileText: [],
      headers: [],
      status: [],
      statusMsg: [],
      confId: [],
      trackingId: [],
      opsNotes: [],
      campaignVars: [],
      msgRecipientAPIList: [],
      topic: [],
      topicId: [],
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.msg.createDate = moment(this.msg.createDate).toDate();
    this.msg.lastUpdate = moment(this.msg.lastUpdate).toDate();
    if ( this.msg.sentDate) {
      this.msg.sentDate = moment(this.msg.sentDate).toDate();
    }
    if ( this.msg.receivedDate) {
      this.msg.receivedDate = moment(this.msg.receivedDate).toDate();
    }
  }
}
